var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-rdh-c88": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M12 1V12H6V1H12ZM12.5 0H5.5C5.36739 0 5.24021 0.0526784 5.14645 0.146447C5.05268 0.240215 5 0.367392 5 0.5V12.5C5 12.6326 5.05268 12.7598 5.14645 12.8536C5.24021 12.9473 5.36739 13 5.5 13H12.5C12.6326 13 12.7598 12.9473 12.8536 12.8536C12.9473 12.7598 13 12.6326 13 12.5V0.5C13 0.367392 12.9473 0.240215 12.8536 0.146447C12.7598 0.0526784 12.6326 0 12.5 0Z",
    fill: "#013d50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M11 3H7V4H11V3ZM11 6H7V7H11V6ZM11 9H7V10H11V9ZM5 7H3V8H5V7ZM5 9H3V10H5V9ZM14 12H0V13H14V12Z",
    fill: "#013d50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M5 5V12H2V5H5ZM5.5 4H1.5C1.36739 4 1.24021 4.05268 1.14645 4.14645C1.05268 4.24021 1 4.36739 1 4.5V12.5C1 12.6326 1.05268 12.7598 1.14645 12.8536C1.24021 12.9473 1.36739 13 1.5 13H5.5C5.63261 13 5.75979 12.9473 5.85355 12.8536C5.94732 12.7598 6 12.6326 6 12.5V4.5C6 4.36739 5.94732 4.24021 5.85355 4.14645C5.75979 4.05268 5.63261 4 5.5 4Z",
    fill: "#013d50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.774937cdecdc72faaadf0552bc60eb68.svg";
export { ForwardRef as ReactComponent };